import React from 'react';
import { Snackbar, Alert, IconButton, Box, Typography } from '@mui/material';
import { Close, CheckCircle, Error, Warning, Info } from '@mui/icons-material';

const Notification = ({ open, message, severity = 'info', onClose, duration = 6000, details = null }) => {
  const getIcon = () => {
    switch (severity) {
      case 'success':
        return <CheckCircle sx={{ color: '#FFFFFF' }} />;
      case 'error':
        return <Error sx={{ color: '#FFFFFF' }} />;
      case 'warning':
        return <Warning sx={{ color: '#FFFFFF' }} />;
      default:
        return <Info sx={{ color: '#FFFFFF' }} />;
    }
  };

  const getBorderColor = () => {
    switch (severity) {
      case 'success':
        return '#00FF00';
      case 'error':
        return '#FF0000';
      case 'warning':
        return '#FFA500';
      default:
        return '#0099FF';
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ mt: 8 }}
    >
      <Alert
        severity={severity}
        icon={getIcon()}
        onClose={onClose}
        sx={{
          backgroundColor: '#000000',
          border: `2px solid ${getBorderColor()}`,
          borderRadius: 0,
          color: '#FFFFFF',
          minWidth: '400px',
          maxWidth: '600px',
          '& .MuiAlert-icon': {
            color: '#FFFFFF'
          },
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
            sx={{ color: '#FFFFFF' }}
          >
            <Close fontSize="small" />
          </IconButton>
        }
      >
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: details ? 1 : 0 }}>
            {message}
          </Typography>
          {details && (
            <Box sx={{ 
              mt: 1, 
              p: 1, 
              backgroundColor: '#111111', 
              border: '1px solid #333333',
              borderRadius: 0,
              fontFamily: 'monospace',
              fontSize: '0.85rem'
            }}>
              {typeof details === 'object' ? (
                Object.entries(details).map(([key, value]) => (
                  <Typography key={key} variant="caption" sx={{ display: 'block', color: '#CCCCCC' }}>
                    <strong>{key}:</strong> {value}
                  </Typography>
                ))
              ) : (
                <Typography variant="caption" sx={{ color: '#CCCCCC' }}>
                  {details}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default Notification;
